import { Link, useNavigate } from "react-router-dom";
import { BabyImage } from "../../assets/images";
import { default_route } from "../../config";
import './Index.css'

export default function Index() {
    const navigate = useNavigate();

    return <div className="component-container container-big">
        <h1 className="text-center mt-4 mb-4">Bienvenido/a a ALSE</h1>
        <div className="d-flex flex-wrap items-center justify-content-center">
            <img src={BabyImage} alt="Child viking" className="w-100 w-md-33" />
            <div className="w-100 w-md-66 d-flex flex-column items-center justify-content-center">
                <p className="my-1">
                    Buenas! Una cosa...
                </p>
                <p className="my-1">
                    Para que <b>ALSE</b> pueda ser <b>gratis</b>💵 apagamos los servidores cuando nadie los usa🌙
                </p>
                <p className="my-1">
                    Eso significa que <b>el inicio de sesión</b> podría <b>tardar hasta 2 minutos</b>⏱️ mientras que se encienden servidores
                </p>
                <p className="my-1">
                    Gracias por tu paciencia y por darnos una oportunidad 🧡
                </p>
            </div>
            <button onClick={() => navigate(default_route)} className="btn info mt-4 w-50">Iniciar sesión</button>
            <footer className="legal-footer">
                <Link to='/politica-de-privacidad'>🔒 Política de privacidad</Link>
                <Link to='/politica-de-cookies'>🍪 Política de cookies</Link>
                <Link to='/aviso-legal'>⚖️ Aviso legal</Link>
            </footer>
        </div>
    </div>                             
}